module.exports = __webpack_public_path__ + "img/publicFail.fc86fd64.svg";